import React from 'react'
import { useForm } from 'react-hook-form'
import CrudEdit from '~/components/CrudEdit'
import IInspectionItem from '../interfaces/IInspectionItem'
import { useLang } from '~/hooks/useLang'
import { capitalizeFirstLetter } from '~/utils/strings'

export default function Edit() {
  const { translate } = useLang()
  const {
    register,
    handleSubmit,
    control,
    setValue: setFormValue,
    getValues,
    watch,
  } = useForm<IInspectionItem>({})

  const nameValue = watch('name');
  React.useEffect(() => {
    if (nameValue) {
      const capitalized = capitalizeFirstLetter(nameValue);
      if (capitalized !== nameValue) {
        setFormValue('name', capitalized, { shouldValidate: false });
      }
    }
  }, [nameValue, setFormValue]);

  const fields = [
    { name: 'id', type: 'hidden' },
    { 
      name: 'name', 
      type: 'string', 
      required: true, 
      placeholder: translate('Inspection Item Name'),
    },
  ]

  return (
    <CrudEdit
      model={'inspection-item'}
      fields={fields}
      register={register}
      handleSubmit={handleSubmit}
      control={control}
      setFormValue={setFormValue}
      messageSuccess={translate('Inspection item updated successfully!')}
      title={translate('Edit Inspection Item')}
      getValues={getValues}
    />
  )
}
